'use strict';
var OptionContext = require('gems-materials-qci/src/common/utils/domain/otherPackage/OptionContext').OptionContext;
exports.OptionContext = OptionContext;
